import { render, staticRenderFns } from "./com-form-image.vue?vue&type=template&id=5fd48300&"
import script from "./com-form-image.vue?vue&type=script&lang=js&"
export * from "./com-form-image.vue?vue&type=script&lang=js&"
import style0 from "./com-form-image.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports